var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrush = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5121 2.57187C14.1965 1.8875 15.3027 1.8875 15.9871 2.57187L17.4277 4.0125C18.1121 4.69688 18.1121 5.80313 17.4277 6.4875L15.209 8.70625L14.8808 9.03125L13.6121 13.6906C13.4621 14.2469 13.0465 14.6906 12.5027 14.8813L4.24958 17.7812C3.67145 17.9844 3.0277 17.8375 2.59645 17.4062C2.1652 16.975 2.0152 16.3281 2.21833 15.75L5.11833 7.49687C5.30895 6.95312 5.7527 6.54062 6.30895 6.3875L10.9683 5.11875L11.2933 4.79375L13.5121 2.575V2.57187ZM11.2777 6.5875L6.7027 7.83437C6.62458 7.85625 6.55895 7.91563 6.53395 7.99375L3.9527 15.3406L7.14645 12.1469C7.0527 11.95 6.99958 11.7312 6.99958 11.5C6.99958 10.6719 7.67145 10 8.49958 10C9.3277 10 9.99958 10.6719 9.99958 11.5C9.99958 12.3281 9.3277 13 8.49958 13C8.26833 13 8.04958 12.9469 7.8527 12.8531L4.65895 16.0469L12.0058 13.4656C12.084 13.4375 12.1433 13.375 12.1652 13.2969L13.4121 8.72188L11.2777 6.5875Z",
  fill: "#F8F9FA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrush);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "73b6e0031e7537a376e16e5fd2009b11.svg";